import { Colors } from "./types";

export const baseColors = {
  failure: "#ED4B9E",
  primary: "#2950aa",
  primaryBright: "#2950aa",
  primaryDark: "#2950aa",
  secondary: "#0e0d6b",
  success: "#31D0AA",
  warning: "#FFB237",
};

export const brandColors = {
  binance: "#F0B90B",
};

export const lightColors: Colors = {
  ...baseColors,
  ...brandColors,
  secondary: "#5fafee",
  background: "#343135",
  backgroundDisabled: "#3c3742",
  contrast: "#FFFFFF",
  invertedContrast: "#191326",
  input: "#483f5a",
  primaryDark: "#0098A1",
  tertiary: "#353547",
  text: "#EAE2FC",
  textDisabled: "#666171",
  textSubtle: "#c9c4d4",
  borderColor: "#524B63",
  card: "#27262c",
};

export const darkColors: Colors = {
  ...baseColors,
  ...brandColors,
  background: "#FAF9FA",
  backgroundDisabled: "#E9EAEB",
  contrast: "#191326",
  invertedContrast: "#FFFFFF",
  input: "#eeeaf4",
  tertiary: "#EFF4F5",
  text: "#0d0b85",
  textDisabled: "#BDC2C4",
  textSubtle: "#5fafed",
  borderColor: "#E9EAEB",
  card: "#FFFFFF",
};